import React, { useCallback, useEffect, useState } from 'react';
import api from '../../api/axios';

const LABELS = {
  operational: 'Operationeel',
  degraded: 'Beperkt',
  action_required: 'Actie nodig',
  not_configured: 'Niet ingesteld',
};

export default function MeetingProviderHealth({ campaignId, provider, refreshKey }) {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!campaignId) return;
    setLoading(true);
    try { setHealth((await api.get(`/agent/campaigns/${campaignId}/meeting-provider-health`)).data); }
    catch { setHealth(null); }
    finally { setLoading(false); }
  }, [campaignId]);

  useEffect(() => { load(); }, [load, provider, refreshKey]);
  if (!provider || provider === 'none') return null;

  const status = health?.status || (loading ? 'checking' : 'unknown');
  const label = loading ? 'Controleren…' : LABELS[status] || 'Status onbekend';
  const issues = health?.issues || [];
  return <div className={`meeting-provider-health ${status}`}>
    <div className="meeting-provider-health-head">
      <div><span className="meeting-provider-health-dot" /><strong>Integratiestatus: {label}</strong></div>
      <button type="button" className="meeting-provider-health-refresh" onClick={load} disabled={loading}>Opnieuw controleren</button>
    </div>
    {health?.sync?.lastSyncAt && <p>Laatste synchronisatie: {new Date(health.sync.lastSyncAt).toLocaleString('nl-NL')}</p>}
    {issues.length > 0
      ? <ul>{issues.slice(0, 4).map((item) => <li key={item.code}>{item.message || item.code}</li>)}</ul>
      : !loading && <p>Boekingslink, providerkoppeling en eventterugkoppeling zijn gereed voor deze campagne.</p>}
  </div>;
}
